const buildParams = (prefix, data, noRecurse = false) => {
    let qs = [];
    let type = typeof data;

    if (Array.isArray(data) && !noRecurse) {
        data.forEach((value) => {
            qs.push(buildParams(prefix, value));
        });
        return qs;
    }

    if ((type === 'function' || type === 'object') && !noRecurse) {
        for (const name in data) {
            qs.push(buildParams(`${prefix}[${name}]`, data[name]));
        }
        return qs;
    }
    if (noRecurse && Array.isArray(data)) {
        data = `${JSON.stringify(data)}`;
    }
    qs.push(`${encodeURIComponent(prefix)}=${encodeURIComponent(data)}`);
    return qs;
};

export function serialize(data, noRecurse = false) {
    let qs = [];

    Object.keys(data).forEach((key) => {
        qs.push(buildParams(key, data[key], noRecurse));
    });

    return [].concat.apply([], qs).join('&');
}

export const iconBase = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    style: { fill: 'currentColor', verticalAlign: 'middle' },
    preserveAspectRatio: 'xMidYMid meet'
};

export function titleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export function parseBool(value) {
    if (value.toLowerCase() === 'true') {
        return true;
    }
    if (value.toLowerCase() === 'false') {
        return false;
    }
    return value;
}

export function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        error.json = response.json();
        throw error;
    }
}

export function parseJson(response) {
    return response.json();
}

export function updateAllItems(state = [], data) {
    return state.map((item) => {
        return {
            ...item,
            ...data
        };
    });
}

export function updateItem(state = [], id, data) {
    return state.map((item) => {
        if (item.sku !== id) {
            return item;
        }

        return {
            ...item,
            ...data
        };
    });
}

export function toPennies(val) {
    return val ? parseInt(val.toString().replace('.', ''), 10) : 0;
}

export function formatCurrency(val) {
    val = toPennies(val).toString();
    val = val === '0' ? val + '00' : val;
    return val.substring(0, val.length - 2) + '.' + val.substring(val.length - 2);
}

export function getContrastColor(hc) {
    const [r, g, b] = [0, 2, 4].map((p) => {
        return parseInt(hc.substr(p, 2), 16);
    });
    let yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? 'black' : 'white';
}

export const sorts = {
    asc(a, b) {
        let at = typeof a === 'string' ? a.toLowerCase() : a;
        let bt = typeof b === 'string' ? b.toLowerCase() : b;
        if (at < bt) {
            return -1;
        } else if (at > bt) {
            return 1;
        } else {
            return 0;
        }
    },
    desc(a, b) {
        let at = typeof a === 'string' ? a.toLowerCase() : a;
        let bt = typeof b === 'string' ? b.toLowerCase() : b;
        if (at > bt) {
            return -1;
        } else if (at < bt) {
            return 1;
        } else {
            return 0;
        }
    }
};

export function param(obj) {
    let str = '';
    for (var key in obj) {
        if (str !== '') {
            str += '&';
        }
        str += key + '=' + obj[key];
    }
    return str;
}

// http://davidwalsh.name/javascript-debounce-function
export function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export function includesAny(string, values = []) {
    return values.reduce((v, value) => {
        return v || string.includes(value);
    }, false);
}

export const guid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

export const splitCSV = (text) => {
    if (!text) return [];
    return text
        .replace(/(,|\n|\r)/g, ';') // turn commas and all new lines to ;
        .split(';') // Split the string on the ;
        .map((v) => v.trim()) // trim the values to remove extra whitespace
        .filter(Boolean) // filter out empty lines
        .filter((val, index, self) => self.indexOf(val) === index); // filter out duplicates
};
